/** @format */
import { api } from 'utility';
import { getToggleAutoSettelmentUrl, getCreditUrl, getShebaServiceUrl } from 'URLs';
export function deleteSettlement(param) {
  return api.delete(getToggleAutoSettelmentUrl(), { params: { ...param } });
}

export function credit() {
  return api.get(getCreditUrl()).then((res) => res.data);
}

export function getSheba(params) {
  return api.get(getShebaServiceUrl(), { params }).then((res) => res.data);
}

export function getAutoSettlement(params) {
  return api.get(getToggleAutoSettelmentUrl(), { params }).then((res) => res.data);
}

export function autoSettlement(param) {
  return api.post(getToggleAutoSettelmentUrl(), {
    ...param,
  });
}
